import Header from "../Header";
import Footer from "../Footer";
// import { useDispatch } from 'react-redux';
import { useState, useEffect } from "react";
import { getMyUserDetails, getUserAccessScreenWise } from '../../service/UserService';
import { useAccount } from '../context/AccountProvider';
import { getMyDetails } from "../../service/myDeatils";
// import { fetchUserSearchCount } from '../../redux/searchSlice';
// import { IPSERAHCOUNT, USERSEPURCHASEPLAN, USERSERACHCOUNT, USER_ACCESS, USER_DATA, USER_SCREEN_ACTION } from '../../redux/actions';

function Layout({ children }) {
  // const dispatch = useDispatch();
  // const { setUserDetails } = useAccount();
  const [userDetails, setUserDetails] = useState({})

  useEffect(() => {
    console.log('Main layout loaded');
    if (localStorage.getItem('token') !== null) {
      getMyUserDetailsHandler();
    }
    else {
      // dispatch(fetchUserSearchCount(''))
    }
    getMyUserDetailsHandler();
  }, []);

  const getMyUserDetailsHandler = async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const res = await getMyDetails();
    if (res.id) {
      console.log('user id in main layout', res.id);
      getUserAccessOfUser(res.id)
    }
    // dispatch({ type: USER_DATA, payload: res });
    console.log(res, 'resData');
    setUserDetails(res);
    // dispatch(fetchUserSearchCount(res.id))
    // dispatch({ type: IPSERAHCOUNT, payload: false });
    // dispatch({ type: USERSERACHCOUNT, payload: false });
    // dispatch({ type: USERSEPURCHASEPLAN, payload: false });
  };

  // useEffect(() => {
  //   async function loadUser() {
  //     try {
  //       const resp = await getMyDetails();
  //       setUserDetails(resp);
  //     } catch (err) {
  //       console.error("Failed to load user details:", err);
  //     }
  //   }
  //   loadUser();
  // }, []);

  const getUserAccessOfUser = async (id) => {
    const res = await getUserAccessScreenWise(id);

    const uniqueSlugNames = [...new Set(res?.data?.map(screen => screen?.slug_name))];
    const uniqueScreenActions = [...new Set(res?.data?.map(role => role.actions?.flat()?.map(item => item.action.toLowerCase())).flat())];

    console.log(uniqueScreenActions, 'USER_ACCESS', uniqueSlugNames);
    // dispatch({ type: USER_ACCESS, payload: uniqueSlugNames });
    // dispatch({ type: USER_SCREEN_ACTION, payload: uniqueScreenActions });
  }


  return (
    <>
      <Header />
      <main style={{ minHeight: "80vh", marginTop: "80px" }}>
        {children}
      </main>
      <Footer />
    </>
  );
}

export default Layout;
